ChangeRolePopoverView = require 'views/member/change-role-popover-view'
Controller = require 'controller'

module.exports = class OrganizationChangeRolePopoverView extends ChangeRolePopoverView
  apiChangeRole: (type) ->
    super
    if type != 'admin' && @isAdminAndMe()
      # We just de-admined ourselves, which means we can't see this page anymore; go to the overview page
      Controller.navigate Controller.getOrganizationUrl(@parent), { trigger: true }



// WEBPACK FOOTER //
// ./app/scripts/views/member/organization-change-role-popover-view.coffee